import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { IonCard, IonCardContent } from '@ionic/angular/standalone';
import { DecaStoreService } from '../deca-store.service';

@Component({
  selector: 'lib-deca-counters-carrier',
  templateUrl: './deca-counters-carrier.component.html',
  styleUrls: ['./deca-counters-carrier.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonCardContent, IonCard],
})
export class DecaCountersCarrierComponent {
  private readonly decaStoreService = inject(DecaStoreService);

  protected readonly upcomingDocumentsAsCarrierCount = computed(
    () => this.decaStoreService.upcomingDocumentsAsCarrier().totalElements,
  );
  protected readonly pastDocumentsAsCarrierCount = computed(
    () => this.decaStoreService.pastDocumentsAsCarrier().totalElements,
  );

  protected readonly todayDocumentsAsCarrierCount = computed(
    () => this.decaStoreService.todayDocumentsAsCarrier().totalElements,
  );

  protected readonly nextDocumentsAsCarrierCount = computed(
    () => this.upcomingDocumentsAsCarrierCount() - this.decaStoreService.todayDocumentsAsCarrier().totalElements,
  );
}
